<template>
  <div class="kv-item">
    <div class="time">{{ guest.time }}</div>
    <div class="subject-title">
      {{ guest.subjectTitle }}
    </div>
    <div
      class="person-info"
      :class="{ mul_guest: index !== 0 }"
      v-for="(info, index) in guest.personInfo"
      :key="index"
    >
      <div
        class="avatar"
        :style="{
          background: `#f3f3f3 url(${info.avatarSrc}) no-repeat center / cover`,
        }"
      ></div>
      <div class="info-text">
        <div class="name-wrap">
          <div class="name">{{ info.name }}</div>
          <div class="replay-btn-wrapper">
            <img
              v-if="guest.repalySrc && index === 0"
              class="repaly-btn"
              :src="
                guest.repalySrc2
                  ? 'https://summit-img.geekpark.net/if2021/视频一.svg'
                  : 'https://summit-img.geekpark.net/if2021/视频.svg'
              "
              @click="playCurVideo(guest.repalySrc)"
            />
            <img
              v-if="guest.repalySrc2 && index === 0"
              class="repaly-btn"
              src="https://summit-img.geekpark.net/if2021/视频二.svg"
              @click="playCurVideo(guest.repalySrc2)"
            />
            <img
              v-if="guest.repalySrc3 && index === 0"
              class="repaly-btn"
              src="https://summit-img.geekpark.net/if2021/视频三.svg"
              @click="playCurVideo(guest.repalySrc3)"
            />
          </div>
        </div>
        <div class="title-info">
          <span class="company-name">{{ info.companyName }}</span>
          <span class="title">{{ info.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KvItem",
  data() {
    return {};
  },
  computed: {
    curVideoSrc() {
      return this.$store.state.curVideoSrc;
    },
  },
  props: {
    guest: Object,
  },
  methods: {
    playCurVideo(vSrc) {
      if (!vSrc) return;
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      if (vIframeWrapper.style.display === "none") {
        vIframeWrapper.style.display = "block";
        vIframe.src = vSrc;
        this.$store.commit("handleVSrcToggle", vSrc);
      } else {
        if (vSrc === this.curVideoSrc) return;
        vIframe.src = vSrc;
        this.$store.commit("handleVSrcToggle", vSrc);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.kv-item {
  width: 90vw;
  background: #fff;
  padding: 4px 14px 8px 14px;
  margin: 0 auto 10px auto;
  position: relative;
  z-index: 2;
  .time {
    color: #4132f0;
    font-size: 3.8vw;
    font-weight: 800;
  }
  .subject-title {
    font-size: 3.5vw;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .person-info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    &.mul_guest {
      margin-top: 10px;
    }
    .avatar {
      width: 10vw;
      height: 10vw;
      border-radius: 50%;
      margin-right: 10px;
    }
    .info-text {
      flex: 1;
      .name-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          color: #4132f0;
          font-weight: 600;
          font-size: 4vw;
        }
        .repaly-btn {
          height: 4.6vw;
          width: auto;
          margin-left: 5px;
        }
      }
    }
    .title-info {
      .company-name {
        font-size: 3.4vw;
        margin-right: 10px;
      }
      .title {
        font-size: 3.4vw;
        color: #666666;
      }
    }
  }
}
</style>